import {isLoggedIn} from 'utils/auth'
import {injectReducer} from '../../store/reducers';
import {filterValuesReducer} from '../Home/modules/home';

export default (store) => ({
  path: 'ecom-order-management',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      /*  Return getComponent   */
      const EcomOrderManagement = require('./containers/EcomOrderManagementContainer').default;
      callback(null, EcomOrderManagement)

      /* Webpack named bundle   */
    }, 'EcomOrderManagement')
  }
})



// WEBPACK FOOTER //
// ./src/routes/EcomOrderManagement/index.js